import { BUSINESS_TYPE, CSN_INFO_PAGE_PART_TYPES, CSN_INFO_ALSO_NOTIFY_PAGE_PART_TYPES, CSN_INFO_AGENT_PARTY_PAGE_PART_TYPES, EXCLUDE_ELEMENTS, BUSINESS_BATCH_EXCLUDE_ELEMENTS, READONLY_ELEMENTS, PAGE_PART_TYPE, APPLICATION_SCENE } from '@/class/cargo/model/parameters/AiCustomPageConstants'

export function getBusinessType(businessType) {
  for (const [, value] of Object.entries(BUSINESS_TYPE)) {
    if (value.value === businessType) {
      return value
    }
  }
  return null
}

/**
 * 检查是否为收发通分块类型
 * @param {number} blockType 分块类型值
 * @returns {boolean} 是否为收发通分块类型
 */
export function isCsnInfoPagePartType(blockType) {
  return CSN_INFO_PAGE_PART_TYPES.some(type => type.value === blockType)
}

/**
 * 检查是否为包含第二通知人信息的收发通分块类型
 * @param {number} blockType 分块类型值
 * @returns {boolean} 是否为包含第二通知人的收发通分块类型
 */
export function isCsnInfoAlsoNotifyPagePartType(blockType) {
  return CSN_INFO_ALSO_NOTIFY_PAGE_PART_TYPES.some(type => type.value === blockType)
}

/**
 * 检查是否为包含代理信息的收发通分块类型
 * @param {number} blockType 分块类型值
 * @returns {boolean} 是否为包含代理信息的收发通分块类型
 */
export function isCsnInfoAgentPartyPagePartType(blockType) {
  return CSN_INFO_AGENT_PARTY_PAGE_PART_TYPES.some(type => type.value === blockType)
}

/**
 * 检查是否为排除元素
 * @param {object} element 元素对象
 * @returns {boolean} 是否为排除元素
 */
export function isExcludeElement(element) {
  return EXCLUDE_ELEMENTS[element.pageType]?.has(element.elementName) || false
}

/**
 * 检查在业务批量模式下是否为排除元素
 * @param {object} element 元素对象
 * @param {number} applicationScene 应用场景
 * @returns {boolean} 是否为排除元素
 */
export function isExcludeElementInBatchMode(element, applicationScene) {
  // 如果是业务批量模式，使用批量模式的排除规则
  if (applicationScene === APPLICATION_SCENE.BUSINESS_BATCH.value) {
    // 批量模式的排除逻辑：
    // 1. 先检查单笔模式的排除规则（继承单笔模式的限制）
    const isExcludedInSingleMode = isExcludeElement(element)
    if (isExcludedInSingleMode) {
      return true
    }

    // 2. 再检查批量模式特有的排除规则（在单笔模式基础上进一步限制）
    const isExcludedInBatchMode = BUSINESS_BATCH_EXCLUDE_ELEMENTS[element.pageType]?.has(element.elementName) || false
    return isExcludedInBatchMode
  }
  // 其他模式使用默认排除规则
  return isExcludeElement(element)
}

/**
 * 检查是否为只读分块
 * @param {object} pagePart 分块对象
 * @returns {boolean} 是否为只读分块类型
 */
export function isReadOnlyPagePart(pagePart) {
  if (pagePart.blockType === PAGE_PART_TYPE.BUSINESS_ELEMENTS.value) {
    return pagePart?.businessConfig?.isReadonly || false
  } else if (isCsnInfoPagePartType(pagePart.blockType)) {
    return pagePart?.csnConfig?.isReadonly || false
  }
  return false
}

/**
 * 检查是否为默认只读元素
 * @param {object} element 元素对象
 * @returns {boolean} 是否为默认只读元素
 */
export function isDefaultReadOnlyElement(element) {
  return READONLY_ELEMENTS[element.pageType]?.has(element.elementName) || false
}

/**
 * 检查是否为只读元素
 * @param {object} element 元素对象
 * @returns {boolean} 是否为只读元素
 */
export function isReadOnlyElement(element) {
  return isDefaultReadOnlyElement(element) || element.isReadonly || false
}
